import { t } from "i18next";

export const DOCUMENT_IDS = {
    CV: "cv",
    CPR_CERTIFICATE: "hlr_intyg",
    REFERENCES: "referenser",
    LICENSE: "legitimation",
    IVO_LICENSE: "ivo_license",
    HOSP_LICENSE: "hosp_license",
    SPECIALIST_CERTIFICATE: "specialistbevis",
    PASSPORT: "passport_or_driver_license",
    CRIMINAL_RECORD: "criminal_record",
    OTHER: "file",
}

// Keep historical document labels, but only offer candidate-owned types for uploads.
export const CANDIDATE_DOCUMENT_IDS = Object.values(DOCUMENT_IDS).filter(
    (type) => type !== DOCUMENT_IDS.IVO_LICENSE && type !== DOCUMENT_IDS.HOSP_LICENSE
);

export const getDocumentNameType = (documentType) => {
    if (documentType === DOCUMENT_IDS.CV) {
        return t('cv');
    } else if (documentType === DOCUMENT_IDS.CPR_CERTIFICATE) {
        return t('cpr');
    } else if (documentType === DOCUMENT_IDS.REFERENCES) {
        return t('references');
    } else if (documentType === DOCUMENT_IDS.LICENSE) {
        return t('identification');
    } else if (documentType === DOCUMENT_IDS.IVO_LICENSE) {
        return t('ivo_license');
    } else if (documentType === DOCUMENT_IDS.HOSP_LICENSE) {
        return t('hosp_license');
    } else if (documentType === DOCUMENT_IDS.SPECIALIST_CERTIFICATE) {
        return t('specialist_certificate');
    } else if (documentType === DOCUMENT_IDS.PASSPORT) {
        return t('id_card');
    } else if (documentType === DOCUMENT_IDS.CRIMINAL_RECORD) {
        return t('criminal_record');
    } 

    return t('other_document');
}



